<template>
  <div id="form-editor" class="data-list-container">
    <div class="vx-col w-full mb-base">
      <vx-card collapse-action
               title="Form"
               title-color="primary"
               subtitle="Complete form details.">
        <div id="addform-step-1" class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Name</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="current_form.name" v-validate="'required'"/>
            <span class="text-danger text-sm float-left">{{ errors.first('current_form.name') }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Custom Link</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span>https://{{subdomain}}.quicksend.asia/buy/</span>
              </div>
            </template>
            <vs-input id="addform-step-2" v-model="current_form.custom_link" v-validate="'required'"/>
            <span class="text-danger text-sm float-left">{{ errors.first('current_form.link') }}</span>
            </vx-input-group>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Layout</span>
          </div>
          <div id="addform-step-3" class="vx-col sm:w-1/6 w-full">
            <v-select label="name" :options="layout_options" v-model="current_form.layout" v-validate="'required'"/>
            <span class="text-danger text-sm float-left">{{ errors.first('current_form.layout') }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Enable Countdown</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-switch id="addform-step-4" v-model="current_form.enable_countdown" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="current_form.enable_countdown">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Count Down Start</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <flat-pickr :config="configdateTimePicker" v-model="current_form.countdown_start_at" placeholder="Count Down Start" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Start At</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <flat-pickr id="addform-step-5" :config="configdateTimePicker" v-model="current_form.start_at" placeholder="Start Date" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>End At</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <flat-pickr id="addform-step-6" :config="configdateTimePicker" v-model="current_form.end_at" placeholder="End Date" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Active</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-switch id="addform-step-7" v-model="current_form.status" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Custom Fields</span>
          </div>
          <div id="addform-step-8" class="vx-col sm:w-5/6 w-full">
            <vs-table :data="current_form.custom_field">
              <template slot="thead">
                <vs-th>Name</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Included</vs-th>
                <vs-th>Required</vs-th>
                <vs-th width="6em;">Action</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="tr.name">
                    {{ tr.name }}
                  </vs-td>

                  <vs-td :data="tr.type">
                    {{ tr.type }}
                  </vs-td>

                  <vs-td :data="tr.included">
                    <vs-switch v-if="tr.is_locked" disabled="true" v-model="tr.included" />
                    <vs-switch v-else v-model="tr.included" @change="changeCustomFieldIncluded()"/>
                  </vs-td>

                  <vs-td :data="tr.required">
                    <vs-switch v-if="tr.is_locked" disabled="true" v-model="tr.required" />
                    <vs-switch v-else v-model="tr.required" @change="changeCustomFieldRequired()"/>
                  </vs-td>

                  <vs-td class="whitespace-no-wrap">
                    <feather-icon v-if="tr.is_builtin" disabled icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteDisabled" />
                    <feather-icon v-else icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteCustomField(tr.name)" />
                  </vs-td>
                </vs-tr>

                <vs-tr>
                  <vs-td>
                    <vs-input class="w-full" v-model="cur_custom_field.name" />
                  </vs-td>

                  <vs-td>
                    <v-select :options="custom_field_types" v-model="cur_custom_field.type" />
                  </vs-td>

                  <vs-td>
                    <vs-switch v-model="cur_custom_field.included" />
                  </vs-td>

                  <vs-td >
                    <vs-switch v-model="cur_custom_field.required" />
                  </vs-td>

                  <vs-td class="whitespace-no-wrap">
                    <feather-icon icon="PlusSquareIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="addCustomField()" />
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-col w-full mb-base">
      <vx-card collapse-action
               title="Products"
               title-color="primary"
               subtitle="Select products to associate with this form">

        <div class="vx-row mb-6 xl:w-2/3 sm:w-full">
          <div class="vx-col mb-6 xl:w-2/5">
            <v-select id="addform-step-9" label="name" :options="non_selected_products" v-model="selected_product" />
          </div>
          <div class="vx-col xl:w-1/5">
            <vs-button color="success" type="filled" @click.stop="addProduct">Add Product</vs-button>
          </div>
        </div>

        <vs-table :data="selected_products" v-if="selected_products.length > 0">

          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Description</vs-th>
            <vs-th>Category</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="tr.name">
                {{ tr.name }}
              </vs-td>

              <vs-td :data="tr.description">
                {{ tr.description }}
              </vs-td>

              <vs-td :data="tr.category_name">
                {{ tr.category_name}}
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteProduct(tr.id)" />
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div class="vx-col w-full mb-base">
      <vx-card collapse-action
               title="Users"
               title-color="primary"
               subtitle="Select users to associate with this form">

        <div class="vx-row mb-6 xl:w-2/3 sm:w-full">
          <div class="vx-col mb-6 xl:w-2/5">
            <v-select label="email" :options="non_selected_users" v-model="selected_user" />
          </div>
          <div class="vx-col xl:w-1/5">
            <vs-button color="success" type="filled" @click.stop="addUser">Add User</vs-button>
          </div>
        </div>

        <vs-table :data="selected_users" v-if="selected_users.length > 0">

          <template slot="thead">
            <vs-th>Email</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Phone Number</vs-th>
            <vs-th>Role</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="tr.email">
                {{ tr.email }}
              </vs-td>

              <vs-td :data="tr.firstname">
                {{ `${tr.first_name} ${tr.last_name}` }}
              </vs-td>

              <vs-td :data="tr.phone_number">
                {{ tr.phone_number }}
              </vs-td>

              <vs-td :data="tr.role_name">
                {{ tr.role_name}}
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteUser(tr.id)" />
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>

      </vx-card>
    </div>
    <div class="vx-col w-full mb-base">
        <div class="vx-row">
          <div class="vx-col ml-auto mr-auto">
            <vs-button id="addform-step-10" class="mr-3 mb-2" size="large" @click.stop="saveEdit">Save</vs-button>
            <vs-button color="warning" type="border" class="mr-3 mb-2" size="large" @click.stop="cancelEdit">Cancel</vs-button>
          </div>
        </div>
    </div>
    <v-tour name="addFormTour" :steps="steps"></v-tour>
  </div>

</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import router from '@/router';
import vSelect from 'vue-select'
import axios from '@/axios';

const dialogs = {
  invalidForm: (error) => {
    return {
      color: "danger", 
      title: "Invalid Form Specified",
      text: "Sorry, we cannot find the form you want to edit.",
      accept: () => {
        router.push('/forms');
      },
      close: () => {
        router.push('/forms');
      }
    }
  }, 

  saveFormFailed: (error) => {
    if (_.isEmpty(error)) error = "Sorry, we cannot save the form";

    return {
      color: "danger", 
      title: "Cannot Save Form",
      text: error,
      accept: () => {
        console.dir(error); // intentional for debug
      }
    }
  },

  incompleteAssets: (msg) => {
    return {
      color: "danger", 
      title: "Cannot Create Form",
      text: msg,
      accept: () => {
        router.push('/forms');
      },
      close: () => {
        router.push('/forms');
      }
    }
  },

  expired: (error) => {
    return {
      color: "danger", 
      title: "Package Expired!",
      text: "Opps, looks like your package already expired, kindly subscribe a new one.",
      accept:() => {
        router.push({name: 'billing-current-plan'})
      },
      close:() => {
        router.push({name: 'billing-current-plan'})
      }
    }
  },
  
	exceeded: (error) => {
		return {
      color: "danger", 
      title: "Form Limit Exceeded.",
      text: "Opps, your form creation has reached the limit.",
      accept:() => {
        router.push({name : 'dashboard'})
      },
      close:() => {
        router.push({name : 'dashboard'})
      }
    }
	}
}

const notifs = {
  error: (msg) => {
    return {
      title: 'Error',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'danger'
    }
  },

  success: (msg) => {
    return {
      title: 'Success',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-check-circle',
      color: 'success'
    }
  }
}

const layoutNames = [ 'Dropdown', 'Grid', 'Card' ];

const valid_date_or_today = (datestring) => {
  let new_date = new Date(datestring);
  return new_date === 'Invalid Date' ? new Date(): new_date; 
}

export default {

  components: {
    'v-select': vSelect,
    flatPickr,
  },

  data () {
    return {
      mode: 'create',
      selected_users: [],
      selected_user: {},

      selected_products: [],
      selected_product: {},

      current_form: {
        "id": 0,
        "name": "",
        "custom_link": "",
        "layout": "",
        "enable_countdown": 0,
        "countdown_start_at": new Date(),
        "status": "",
        "start_at": new Date(),
        "end_at": new Date(),
        "custom_field": [{
          "name": "Name",
          "type": "text",
          "included": true,
          "required": true,
          "is_builtin": true,
          "is_locked": true,
        }, {
          "name": "Phone",
          "type": "number",
          "included": true,
          "required": true,
          "is_builtin": true,
          "is_locked": true,
        }, {
          "name": "Email",
          "type": "email",
          "included": true,
          "required": true,
          "is_builtin": true,
          "is_locked": false,
        }],
      },

      cur_custom_field: {
        "name": "",
        "type": "",
        "included": false,
        "required": false,
        "is_builtin": false,
        "is_locked": false,
      },

      custom_field_types: ["text", "number", "email", "date", "yesno"],

      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i'
      },

      layout_options: [ 'Dropdown', 'Grid', 'Card' ],
      available_users: [],
      available_products: [],
      current_organization: {},
      subdomain: '',
      steps: [
        {
          target: '#addform-step-1', 
          header: {
            title: 'Form Name',
          },
          content: `Give this form a name and click on <strong>next</strong>.`,
          params:{
              placement: 'top'
          }
        },
        {
          target: '#addform-step-2', 
          header: {
            title: 'Customise Your Form Link',
          },
          content: `Fill in the back part of the link. It can be any texts or text related to the form or your products. Click on <strong>next</strong>.`,
          params:{
              placement: 'top'
          }
        },
        {
          target: '#addform-step-3', 
          header: {
            title: 'Layout',
          },
          content: `Choose any layout for the form to showcase your products and click on <strong>next</strong>.`,
          params:{
              placement: 'top'
          }
        },
        {
          target: '#addform-step-4', 
          header: {
            title: 'Countdown Enabler',
          },
          content: `This is an optional feature. Turn it on if you’d like to enable countdown till the form’s start date and time. Click on <strong>next</strong>.`,
          params:{
              placement: 'top'
          }
        },
        {
          target: '#addform-step-5', 
          header: {
            title: 'Start At',
          },
          content: `Choose the date and time to start this form. Click on <strong>next</strong>.`,
          params:{
              placement: 'top'
          }
        },
        {
          target: '#addform-step-6', 
          header: {
            title: 'End At',
          },
          content: `Choose the date and time to end this form. Click on <strong>next</strong>.`,
          params:{
              placement: 'top'
          }
        },
        {
          target: '#addform-step-7', 
          header: {
            title: 'Active Status',
          },
          content: `Click on the slider to activate this form right after completion. Click on <strong>next</strong>.`,
          params:{
              placement: 'top'
          }
        },
        {
          target: '#addform-step-8', 
          header: {
            title: 'Custom Fields',
          },
          content: `Add additional field if you’d like to request more information from buyers or just click on <strong>Next</strong>.`,
          params:{
              placement: 'top'
          }
        },
        {
          target: '#addform-step-9', 
          header: {
            title: 'Add Product',
          },
          content: `Select the sample product or any product to be added, click on ‘Add Product’ button and then click on <strong>Next</strong>.`,
          params:{
              placement: 'top'
          }
        },
        {
          target: '#addform-step-10', 
          header: {
            title: 'Save Form',
          },
          content: `Click to save this form now.`,
          params:{
              placement: 'top'
          }
        },
      ]
    }
  },

  created(){
    if(this.$store.state.user.organizations.find(o => o.organization_id === this.$store.state.organization.current_organization[0].id)  !== null){
			let current_package_limit = this.$store.state.user.organizations.find(o => o.organization_id === this.$store.state.organization.current_organization[0].id)
			this.$store.dispatch('subscription/getSubscriptionSummary').then(() => {
				if(!((this.$store.state.subscription.subscription_summary.total_form_quota - this.$store.state.subscription.subscription_summary.total_form_created) > 0)){
					this.$vs.dialog(dialogs.exceeded())
				}
			})
		}else{
			this.$vs.dialog(dialogs.expired())
		}
  },

  computed:  {

    non_selected_users() {
      let ids = this.selected_users.map((x) => x.id);
      return this.available_users.filter(x => ids.indexOf(x.id) < 0);
    },

    non_selected_products() {
      console.log({
        'selected': this.selected_products,
        'avail': this.available_products
      });
      let ids = this.selected_products.map((x) => x.id);
      return this.available_products.filter(x => ids.indexOf(x.id) < 0);
    },

  },

  methods: {

    addUser() {
      if (_.isEmpty(this.selected_user)) return;
      this.selected_users.push(this.selected_user);
      this.selected_user = {};
    },

    addProduct() {
      if (_.isEmpty(this.selected_product)) return;
      this.selected_products.push(this.selected_product);
      this.selected_product = {};
    },

    deleteUser(user_id) {
      this.selected_users = this.selected_users.filter(x => x.id !== user_id);
    },

    deleteProduct(product_id) {
      this.selected_products = this.selected_products.filter(x => x.id !== product_id);
    },

    addCustomField() {
      if (this.cur_custom_field.name.trim() == "" || this.cur_custom_field.type.trim() == '""') {
        this.$vs.notify(notifs.error("Please make sure you have entered name and field type."));
        return;
      }

      let existing = this.current_form.custom_field.filter(x => {
        return x.name.toLowerCase().trim() === this.cur_custom_field.name.toLowerCase().trim();
      })

      if (existing.length > 0) {
        this.$vs.notify(notifs.error(`'${this.cur_custom_field.name}' field already added`));
        return;
      }

      this.current_form.custom_field.push(Object.assign({}, this.cur_custom_field));
      this.cur_custom_field.name = "";
      this.cur_custom_field.type = "";
      this.cur_custom_field.included = false;
      this.cur_custom_field.required = false;
      this.cur_custom_field.is_builtin = false;
      this.cur_custom_field.is_locked = false;
      this.$vs.notify(notifs.success("Custom field addedd"));
    },

    deleteCustomField(name) {
      this.current_form.custom_field = this.current_form.custom_field.filter(x => x.name !== name);
    },

    deleteDisabled() {
      this.$vs.notify(notifs.error("Cannot delete builtin custom fields"));
    },

    changeCustomFieldRequired() {
      this.current_form.custom_field = this.current_form.custom_field.map(x => {
        if (x.required) x.included = true;
        return x;
      });
    },

    changeCustomFieldIncluded() {
      this.current_form.custom_field = this.current_form.custom_field.map(x => {
        if (!x.included) x.required = false;
        return x;
      });
    },

    async saveEdit() {
      let user = await this.$store.getters['user/user'];
      let the_form = Object.assign({}, this.current_form);

      // show error on validate
      if (the_form.name.trim() === "") {
        this.$vs.dialog(dialogs.saveFormFailed("Name cannot be empty"));
        return;
      }

      if (the_form.custom_link.trim() === "") {
        this.$vs.dialog(dialogs.saveFormFailed("Custom Link cannot be empty"));
        return;
      }

      if (the_form.layout.trim() === "") {
        this.$vs.dialog(dialogs.saveFormFailed("Layout is not set"));
        return;
      }

      the_form.create_by = user.id;
      the_form.organization_id = this.$store.state.user.current_organization;
      the_form.status = the_form.status ? 1:0;
      the_form.enable_countdown = the_form.enable_countdown ? 1:0;
      the_form.layout = this.layout_options.indexOf(the_form.layout);

      // fix date format
      if (the_form.enable_countdown) {
        the_form.countdown_start_at = valid_date_or_today(the_form.countdown_start_at);
      } else {
        the_form.countdown_start_at = null;
      }
      the_form.start_at = valid_date_or_today(the_form.start_at);
      the_form.end_at = valid_date_or_today(the_form.end_at);

      the_form.products = this.selected_products.map((x) => { return { product_id: x.id } });
      the_form.users = this.selected_users.map((x) => { 
        return { 
          user_id: x.user_id,
          status: 1,
          update_at: new Date(),
        } 
      });


      if (the_form.products.length === 0) {
        this.$vs.dialog(dialogs.saveFormFailed("Form must have at least one product"));
        return;
      }

      if (the_form.users.length === 0) {
        this.$vs.dialog(dialogs.saveFormFailed("Form must associate with at least one user"));
        return;
      }

      try {
        let action = this.mode === 'create' ? 'form/createForm':'form/updateForm';
        await this.$store.dispatch(action, the_form);
        router.push('/forms');
      } catch (e) {
        this.$vs.dialog(dialogs.saveFormFailed(e));
      }
    }, 

    cancelEdit (){
      router.push('/forms');
    },

  },

  async mounted () {
    this.$tours['addFormTour'].start()
    if (isNaN(this.$route.params.form_id) && this.$route.params.form_id !== 'new') {
      this.mode = 'invalid';
      this.$vs.dialog(dialogs.invalidForm());
      return;
    }

    if (this.$route.params.form_id === 'new') {
      this.mode = 'create';
    } else {
      this.mode = 'edit';
    }

    try {
      await this.$store.dispatch('product/getProducts');
      this.available_products = this.$store.state.product.products;
    } catch (e) {
      this.$vs.dialog(dialogs.incompleteAssets("This organization doesn't have any products yet"));
      return;
    }

    try {
      await this.$store.dispatch('organization/getTeamMember', this.$store.state.user.current_organization);
      this.available_users = this.$store.state.organization.current_team_member;
      this.subdomain = this.$store.state.organization.current_team_member[0].subdomain;
      this.current_organization = this.$store.state.organization.current_organization;
    } catch (e) {
      this.$vs.dialog(dialogs.incompleteAssets("This organization doesn't have any team member yet."));
      return;
    }

    try {
      await this.$store.dispatch('organization/getCurrentOrganization', {
        organization_id: this.$store.state.user.current_organization,
        user_id: this.$store.state.user.id,
      });
    } catch (e) {
      this.$vs.dialog(dialogs.incompleteAssets("Oops something wrong please contact quicksend support team"));
      return;
    }

    if (this.mode !== 'edit') {
      return;
    }

    try {
      await this.$store.dispatch('form/getEditForm', this.$route.params.form_id);
    } catch (e) {
      this.$vs.dialog(dialogs.invalidForm(e));
      return;
    }

    //// loading current form
    let ref_products = this.available_products.reduce((dic, cur, idx) => {
      dic[cur.id] = idx;
      return dic;
    }, {});

    let ref_users = this.available_users.reduce((dic, cur, idx) => {
      dic[cur.user_id] = idx;
      return dic;
    }, {});

    // make sure the custom fields is correctly set
    let builtin_fields = this.current_form.custom_field.reduce( (dic, cur, idx) => {
      dic[cur.name] = idx;
      return dic;
    }, {});
    let the_form = JSON.parse(JSON.stringify(this.$store.state.form.current_form));
    for (let key in the_form) {
      if (key === 'products') {
        for (let prd of the_form.products) {
          // form products can contain soft deleted products, so we need to limit 
          // to existing product only
          if (typeof ref_products[prd.product_id] !== 'undefined')
            this.selected_products.push(this.available_products[ref_products[prd.product_id]]);
          continue;
        }
      }

      if (key === 'users') {
        for (let usr of the_form.users) {
          /// user might be deleted, so do like the one we do fro products
          if (typeof ref_users[usr.user_id] !== "undefined")
            this.selected_users.push(this.available_users[ref_users[usr.user_id]]);
          continue;
        }
      }

      if (key === 'layout') {
        this.current_form.layout = this.layout_options[the_form.layout];
        continue;
      }

      let cf_template = JSON.parse(JSON.stringify(this.cur_custom_field));
      if (key === 'custom_field') {
        for (let cust_field of the_form.custom_field) {
          // check if the field has correct properties
          let missing_prop = _.difference(Object.keys(cf_template), Object.keys(cust_field));
          for (let prop of missing_prop) {
            cust_field[prop] = this.cur_custom_field[prop];
          }

          // if the cust_fields is built in we need to replace it, otherwise we add 
          let idx = builtin_fields[cust_field.name];
          if (typeof idx !== 'undefined') {
            this.current_form.custom_field[idx] = cust_field;
          } else {
            this.current_form.custom_field.push(cust_field);
          }
        }

        continue;
      }

      this.current_form[key] = the_form[key];

    }
  },
}
</script>

<style lang="scss">
  .v-tour {
    .v-step {
        // z-index: 55000;
        background-color: rgba(var(--vs-primary),1);
        border-radius: .5rem;
        padding: 1.5rem;
        filter: drop-shadow(0 0 7px rgba(0,0,0,.5));

        .v-step__arrow {
            border-color: rgba(var(--vs-primary),1);
        }

        .vs-button-border:not(.btn-tour-next):not(.btn-tour-finish) {
            border-color: rgba(255, 255, 255, .5) !important;
        }

        .v-step__header{
          background-color: #CE0668;
        }
    }
  }

#form-editor {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
